import { render } from "./RevMyLink.vue?vue&type=template&id=a257a860"
import script from "./RevMyLink.vue?vue&type=script&lang=js"
export * from "./RevMyLink.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue_referralcode\\referral_code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__